<template>
  <div class="skin" :class="[zsTjTheme, isClothSkin ? 'cloth-skin' : '']">
    <div
      class="skin-list"
      :style="{ 'border-bottom-width': hasTjContent ? '1px' : '0' }"
      ref="skinList"
      @scroll="listScroll"
    >
      <template>
        <div
          v-for="(key, index) in list"
          class="item"
          :key="key + dataSource[key].icon.value"
          @click="handleSwitch(key, index)"
        >
          <div class="skin-btn" :class="{ active: key === current.key }" :title="dataSource[key].name.value">
            <img class="icon" alt="" :src="dataSource[key].icon.value" />
            <div v-if="currentSourceData[key] && currentSourceData[key].level" class="level-tag">
              <!-- <img :src="getLevelImg(currentSourceData[key].level)" alt="" /> -->
              <span :class="getCurrentLangValue(currentSourceData[key].level) === '神' ? 'special' : ''">{{
                getCurrentLangValue(currentSourceData[key].level)
              }}</span>
            </div>
            <template v-if="tabActive !== 3">
              <div
                class="tag"
                v-if="
                  dataSource[key].tag.hasValue &&
                    dataSource[key].tag.value.trim() &&
                    dataSource[key].tag.value !== '常驻'
                "
              >
                {{ dataSource[key].tag.value }}
              </div>
            </template>
          </div>
          <!-- 查看测评 -->
          <!--<div class="go-btn" :class="{ active: key === current.key }" v-if="current.evaluation.link.value">
            <a :href="current.evaluation.link.value" target="_blank">
              <img src="@/assets/zs_imgs/skin-go-btn.png" alt="" />
            </a>
          </div>-->
        </div>
      </template>
    </div>
    <!-- <div class="mask-up">
      <img src="@/assets/zs_imgs/drop-up.png" alt="" class="up-img" v-if="hiddenUp" @click="handleScroll('up')" />
    </div>
    <div class="mask-down">
      <img
        src="@/assets/zs_imgs/drop-down.png"
        alt=""
        class="down-img"
        v-if="hiddenDown"
        @click="handleScroll('down')"
      />
    </div> -->
    <div v-if="showName" class="skin-name">
      {{ current.name.value }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    current: {
      type: Object,
      default: () => {
        return {};
      }
    },
    showName: {
      type: Boolean,
      default: true
    },
    currentSourceData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isClothSkin: {
      type: Boolean,
      default: false
    },
    hasTjContent: { type: Boolean, default: true },
    tabActive: { type: Number, default: 0 }
  },
  data() {
    return {
      hiddenUp: false,
      hiddenDown: true,
      listLength: 0
    };
  },
  computed: {
    ...mapGetters(["zsTjTheme", "language"]),
    list() {
      const list = Object.keys(this.dataSource).filter(key => {
        if (this.dataSource[key].icon.hasValue) {
          this.listLength++;
        }
        return this.dataSource[key].icon.hasValue;
      });
      // if (this.isClothSkin) {
      //   // 服装评测只显示配置了数据的皮肤
      //   if (this.loginUser && this.loginUser.is_super) {
      //     return list;
      //   } else {
      //     return list.filter(key => {
      //       return this.currentSourceData[key];
      //     });
      //   }
      // }
      return list;
    }
  },
  watch: {
    listLength() {
      this.hiddenDown = this.listLength >= 4;
    }
  },
  deactivated() {
    this.listLength = 0;
  },
  beforeDestroy() {
    this.listLength = 0;
  },
  methods: {
    handleSwitch(key, index) {
      this.$emit("switch", key, index);
    },
    listScroll() {
      const skinList = this.$refs.skinList;
      const skinListHeight = skinList.scrollHeight;
      if (skinList.scrollTop === 0) {
        this.hiddenUp = false;
        this.hiddenDown = true;
      } else if (skinList.scrollTop + skinList.clientHeight >= skinListHeight) {
        this.hiddenUp = true;
        this.hiddenDown = false;
      } else {
        this.hiddenUp = true;
        this.hiddenDown = true;
      }
    },
    handleScroll(type) {
      const skinList = this.$refs.skinList;
      const SCROLL_NUMBER = 86;
      const upNum = skinList.scrollTop - SCROLL_NUMBER;
      const downNum = skinList.scrollTop + SCROLL_NUMBER;
      const skinListHeight = skinList.scrollHeight;
      console.log(skinListHeight, skinList.scrollTop, upNum, downNum);
      if (type === "up") {
        skinList.scrollTo(0, upNum);
      } else {
        skinList.scrollTo(0, downNum);
      }

      // 判断滚动条位置
      if (skinList.scrollTop === 0) {
        this.hiddenUp = false;
        this.hiddenDown = true;
      } else if (skinList.scrollTop + skinList.clientHeight >= skinListHeight) {
        this.hiddenUp = true;
        this.hiddenDown = false;
      } else {
        this.hiddenUp = true;
        this.hiddenDown = true;
      }
    },
    getLevelImg(level) {
      if (this.zsTjTheme == "light") {
        return require(`@/assets/zs_imgs/light-level-icon-${level}.png`);
      }
      return require(`@/assets/zs_imgs/level-icon-${level}.png`);
    },
    getCurrentLangValue(data) {
      if (data) {
        if (typeof data === "string") {
          return data;
        }
        return this.language ? data[this.language] : "";
      }
      return "";
    }
  }
};
</script>

<style lang="less" scoped>
.skin {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .mask-up {
    position: absolute;
    width: 120px;
    right: 830px;
    bottom: 285px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    //background: url("~@/assets/zs_imgs/mask-up.png") no-repeat;
    //background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 100%, rgba(0, 0, 0, 0) 100%);
    background-blend-mode: color;
    background-size: 100% 100%;
    z-index: 1;

    img {
      width: 32px;
      height: 16px;
      //transform: rotate(180deg);
      cursor: pointer;
    }
  }

  .mask-down {
    position: absolute;
    right: 830px;
    width: 120px;
    height: 120px;
    bottom: -4px;
    display: flex;
    align-items: center;
    justify-content: center;
    //background: url("~@/assets/zs_imgs/mask-down.png") no-repeat;
    background-size: 100% 100%;
    z-index: 1;
    img {
      width: 32px;
      height: 16px;
      cursor: pointer;
    }
  }

  .skin-list {
    display: flex;
    gap: 44px;
    width: 100%;
    height: 101px;
    padding: 0 13px 0;
    .item {
      flex-shrink: 0;
      position: relative;
      width: 64px;
      height: 101px;
      margin-bottom: 38px;
      pointer-events: auto;

      &:last-child {
        margin-bottom: 20px;
      }

      .skin-btn {
        position: relative;
        z-index: 2;
        width: 100%;
        height: 100%;
        cursor: pointer;

        &::before {
          position: absolute;
          bottom: 0;
          left: 0;
          content: "";
          width: 52px;
          height: 26px;
          background: rgba(0, 0, 0, 0.8);
          border-radius: 50%;
          transform: translate(6px, -3px) rotateX(30deg);
        }

        &.active {
          width: 100%;
          height: 100%;

          &::before {
            position: absolute;
            bottom: 0;
            left: 0;
            content: "";
            width: 100%;
            height: 100%;
            border-radius: 0;
            background: url("~@/assets/zs_imgs/skin-active-bg.png") no-repeat;
            background-size: 100% 100%;
            transform: translate(0px, 0px);
            background-position: center 4px;
          }
        }

        .icon {
          position: absolute;
          z-index: 2;
          left: 50%;
          transform: translateX(-50%);
          top: 35px;
          width: 100%;
          object-fit: contain;
        }

        .tag {
          position: absolute;
          top: 25px;
          left: -13px;
          width: 36px;
          height: 18px;
          background: rgba(0, 136, 217, 0.3);
          border-radius: 9px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          line-height: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .level-tag {
          position: absolute;
          // display: flex;
          // justify-content: center;
          // align-items: center;
          top: 25px;
          right: -13px;
          // width: 40px;
          min-width: 40px;
          padding: 0 8px;
          height: 23px;
          background: rgba(255, 255, 255, 0.15);
          border-radius: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 17px;
          text-align: center;
          line-height: 23px;
          img {
            width: 22px;
            height: 15px;
          }
        }
      }

      .go-btn {
        position: absolute;
        top: 9px;
        left: 7px;
        z-index: 1;
        width: 0;
        opacity: 0;
        overflow: hidden;
        height: 32px;
        background: rgba(126, 202, 255, 0.15);
        border-radius: 16px;
        padding: 6px 8px;
        transition: all 0.3s;

        &.active {
          width: 82px;
          opacity: 1;
        }

        img {
          float: right;
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .skin-name {
    position: fixed;
    z-index: 2;
    left: 60%;
    bottom: 27px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 443px;
    height: 59px;
    background: url("~@/assets/zs_imgs/skin-name-bg.png") no-repeat;
    background-size: 100% 100%;
    font-family: 思源宋体;
    font-weight: 800;
    font-size: 18px;
    color: #ffffff;
  }
}

.skin.light {
  .skin-list {
    box-sizing: content-box;
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
    padding-bottom: 12px;
    .item {
      .skin-btn {
        &::before {
          width: 100%;
          height: 100%;
          background: url("~@/assets/zs_imgs/light-skin-bg.png") no-repeat;
          background-size: 100% 100%;
          transform: translate(0px, 0px);
        }
        &.active {
          width: 100%;
          height: 100%;

          &::before {
            background: url("~@/assets/zs_imgs/light-skin-active-bg.png") no-repeat;
            background-size: 100% 100%;
            transform: translate(0px, 0px);
          }
          .level-tag {
            background: rgba(255, 255, 255, 0.75);
            border-radius: 13px;
            color: #333;
            border: none;
          }
        }
        .icon {
          position: absolute;
          z-index: 2;
          left: 50%;
          transform: translateX(-50%);
          top: 25px;
          width: 100%;
          object-fit: contain;
        }
        .level-tag {
          z-index: 10;
          background: rgba(255, 255, 255, 0.75);
          border-radius: 13px;
          border: 1px solid #9e9e9e;
          color: #333;
          .special {
            color: #f60;
          }
        }
      }
    }
  }
}
</style>
